var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalBreakdownPerm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21113_95)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.222656,
    width: 66.4391,
    height: 66.3462,
    rx: 10,
    fill: "#E4E7F5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M30.549 47.5943H20.1174C19.3525 47.5943 18.7266 46.9692 18.7266 46.2053C18.7266 45.4414 19.3525 44.8164 20.1174 44.8164H30.549C31.314 44.8164 31.9399 45.4414 31.9399 46.2053C31.9399 46.9692 31.314 47.5943 30.549 47.5943Z",
    fill: "#8D98B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M38.1988 54.5396H20.1174C19.3525 54.5396 18.7266 53.9146 18.7266 53.1506C18.7266 52.3867 19.3525 51.7617 20.1174 51.7617H38.1988C38.9638 51.7617 39.5897 52.3867 39.5897 53.1506C39.5897 53.9146 38.9638 54.5396 38.1988 54.5396Z",
    fill: "#8D98B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3707 21.2031V28.0633",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0387 17.918V28.0607",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6285 24.8281V28.0631",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6857 13H22.3143C19.0476 13 17 15.3121 17 18.5852V27.4148C17 30.6879 19.0381 33 22.3143 33H31.6857C34.9619 33 37 30.6879 37 27.4148V18.5852C37 15.3121 34.9619 13 31.6857 13Z",
    stroke: "#8D98B7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21113_95",
    x: -15.7773,
    y: -16,
    width: 98.4375,
    height: 98.3477,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21113_95"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21113_95",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalBreakdownPerm);
export default __webpack_public_path__ + "static/media/total-breakdown-perm.816ab376.svg";
export { ForwardRef as ReactComponent };